import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.main.overview');
import { OnInit, ChangeDetectorRef as CDR, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-main-overview',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.main.overview/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class ComponentMainOverviewComponent implements OnInit {
    @Input() grouped: any = { regular: [], fine: [], diagnosis: [], other: [] };
    @Input() stats: any = { total: 0, regular: 0, fine: 0, diagnosis: 0 };
    @Input() selectedProjects: any[] = [];
    @Output() onSelected = new EventEmitter<any[]>();

    /** 펼쳐진 아코디언 상태 */
    public expanded: any = { regular: false, fine: false, diagnosis: false, other: false };

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public toggleAccordion(type: string) {
        this.expanded[type] = !this.expanded[type];
        this.ref.detectChanges();
    }

    public async toggle(project: any) {
        const idx = this.selectedProjects.findIndex((p: any) => p.id === project.id);
        let newList: any[];

        if (idx >= 0) {
            const { code } = await wiz.call('unselect', { project_id: project.id });
            if (code !== 200) return;
            newList = this.selectedProjects.filter((p: any) => p.id !== project.id);
        } else {
            const { code } = await wiz.call('select', { project_id: project.id });
            if (code !== 200) return;
            newList = [...this.selectedProjects, project];
        }

        this.onSelected.emit(newList);
    }

    public isSelected(project: any): boolean {
        if (!Array.isArray(this.selectedProjects)) return false;
        return this.selectedProjects.some((p: any) => p.id === project.id);
    }
}

export default ComponentMainOverviewComponent;